import { Button } from "@material-ui/core";
import AppDialogFullScreen from "@saleor/apps/components/AppDialogFullScreen";
import MyTypography from "@saleor/components/MyTypography";
import { usePmtMatSearchLazyQuery } from "@saleor/graphql";
import useNotifier from "@saleor/hooks/useNotifier";
import { makeStyles } from "@saleor/macaw-ui";
import React, { useState } from "react";
import { useIntl } from "react-intl";

import DialogNoData from "../DialogNoData";
import SearchPMTForm from "./SearchPMTFilter";
import useSearchPMTFilter from "./SearchPMTFilter/useSearchPMTFilter";
import SearchPMTlist from "./SearchPMTList";

const useStyles = makeStyles(
  () => ({
    buttonAction: {
      width: "30%",
      height: 38,
      "& svg": {
        marginRight: 10
      },
      "@media (max-width: 600px)": {
        width: "50%"
      }
    },
    notifyBox: {
      "& h1": {
        fontSize: "22px",
        marginTop: "0px"
      },
      "& b": {
        fontSize: "16px"
      },
      "& span": {
        fontSize: "16px"
      }
    }
  }),
  { name: "ModalSearchForProducts" }
);

const SearchPMTModal = ({
  handleAddToOrder,
  loading,
  saleOrg
}: {
  handleAddToOrder: (a) => void;
  loading: boolean;
  saleOrg: string;
}) => {
  const classes = useStyles();
  const intl = useIntl();
  const notify = useNotifier();

  const { formData, formikData } = useSearchPMTFilter();

  const [open, setOpen] = React.useState(false);
  const [hasError, setHasError] = React.useState(false);
  const [dataPmtSearch, setDataPmtSearch] = useState<any>({});
  const [noDataDialog, setNoDataDialog] = useState<boolean>(false);

  const [getPmtSearch, { loading: dataPMTLoading }] = usePmtMatSearchLazyQuery({
    fetchPolicy: "no-cache",
    onCompleted: data => {
      setDataPmtSearch(data);
      if (data?.pmtMatSearch?.length === 0) {
        setNoDataDialog(true);
      }
      setHasError(false);
    },
    onError: err => {
      setHasError(true);
      let apiMessage = "";
      let errorSrc = "";
      setDataPmtSearch({});

      try {
        if (err.message) {
          const error = JSON.parse(err?.message);
          apiMessage = error?.error;
          errorSrc = error?.error_src;
        }
      } catch (error) {
        // Handle parsing error
        console.error("Error parsing JSON:", error);
      }

      notify({
        status: "error",
        autohide: 4,
        text: (
          <span className={classes.notifyBox}>
            <h1>Something went wrong</h1>
            <b>Error {errorSrc} </b>
            <br />
            <span> {apiMessage}</span>
          </span>
        )
      });
    }
  });

  const isLoading = loading || dataPMTLoading;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        id="searchPMT"
        data-testid="searchPMT"
        variant={"outlined"}
        color={"secondary"}
        className={classes.buttonAction}
        onClick={handleClickOpen}
      >
        <MyTypography variant={"body2"}>
          {intl.formatMessage(
            {
              defaultMessage: "กดค้นหา {boldPMT}"
            },
            {
              boldPMT: <strong>PMT</strong>
            }
          )}
        </MyTypography>
      </Button>
      <AppDialogFullScreen
        open={open}
        onCancel={handleClose}
        title="Product Catalog"
        content={
          <div>
            <SearchPMTForm
              formData={formData}
              formikData={formikData}
              getPmtSearch={getPmtSearch}
              setDataPmtSearch={setDataPmtSearch}
              setHasError={setHasError}
              loading={isLoading}
              saleOrg={saleOrg}
            />
            <SearchPMTlist
              dataPmtSearch={dataPmtSearch}
              hasError={hasError}
              handleAddToOrder={handleAddToOrder}
              loading={isLoading}
            />
            <DialogNoData
              isOpen={noDataDialog}
              title={"ไม่พบข้อมูล Material ใน Product Catalog"}
              content={"โปรดกดค้นหาใหม่"}
              okText={"ค้นหาใหม่"}
              onClose={() => setNoDataDialog(false)}
            />
          </div>
        }
      />
    </>
  );
};

export default SearchPMTModal;
